import MainWrapper from '@features/ui-layout/templates/MainWrapper';
import LoginRegisterTemplate from '@features/user/templates/LoginRegisterTemplate';
import { GetServerSideProps, NextPage } from 'next';
import { getAuthRedirectProps } from '../utils/auth/getAuthRedirectProps';

const LoginPage: NextPage = () => (
  <MainWrapper title="pages.loginRegister.connect">
    <div style={{ padding: '16px' }}>
      <LoginRegisterTemplate />
    </div>
  </MainWrapper>
);

export default LoginPage;

export const getServerSideProps: GetServerSideProps = async context => getAuthRedirectProps(context, ['common']);
